// Ajuda a trocar o roxo padrão (occasionalPurple/secondaryPurple) pela cor de
// destaque do painel atual (produtor ou estabelecimento), definida como
// --panel-accent no body pelo DashHeader. Fora dos painéis (--panel-accent
// não definida) cai no hex original, então é seguro usar em componentes
// compartilhados com o resto do site.
export function panelAccent(fallbackHex) {
    return `var(--panel-accent, ${fallbackHex})`;
}

export function panelAccentAlpha(fallbackHex, alphaHex) {
    const alphaPct = (parseInt(alphaHex, 16) / 255 * 100).toFixed(2);
    return `color-mix(in srgb, var(--panel-accent, ${fallbackHex}) ${alphaPct}%, transparent)`;
}
